// extracted by mini-css-extract-plugin
module.exports = {"root":"_1VY1d","url":"_2EP-j"};